export default __webpack_public_path__ + "static/media/stopEmittingButton.300da8a1.png";